module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/jordy-1600-bfb0c915f2bdc58df0899ae77539d057.webp";